import ConeStarlikeSunburst from '@/assets/graphical-elements/cone-starlike-sunburst.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const ConeStarlikeSunburstIcon = ({className}: IconProps) => <ConeStarlikeSunburst className={cn('fill-current', className)} />
